<template>
  <div class="base">
    <div class="base_box">
      <div
        class="base_box_item"
        @click="navigation(item.id)"
        v-for="(item, index) in form"
        :key="index"
      >
        {{ item.name }}
      </div>
      <div class="base_label">
        <div>妍诗美社(海南)医美健康科技有限公司</div>
        <div>© {{ this.year }} YSTE (Hainan) Aesthetic Medicine Health Technology Co., Ltd All Rights Reserved</div>
        <div class="base_label_1"> <a class="ForReference " target = "_blank" href="https://beian.miit.gov.cn">琼ICP备2022001070号-1</a></div>
        <div class="base_label_2">
           <img style="width: 0.25rem;height: 0.25rem;vertical-align:top;margin-left: 0.2rem;" src="../../../assets/img/pc/badge.png" alt="">
          <a class="ForReference " target = "_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46020502000028">琼公网安备 46020502000028号</a>
        </div>
      </div>
      <div @click="stick" class="stick" v-show="this.btnFlag">
        <img
          class="stick_img"
          src="../../../assets/img/mobile/reach.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: [
       {
          name: "ABOUT US",
          id:4
        },
        {
          name: "PRODUCT CONCEPT",
          id:5
        },
        {
          name: "CONTACT US",
          id:8
        },
        {
          name: "BRAND CONCEPT",
          id:7
        },
        {
          name: "CASE CENTENT",
          id:6
        },
      ],
      btnFlag: false,
      year:'2024'
    };
  },

  mounted() {
    const now = new Date();
this.year = now.getFullYear();
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    navigation(e) {
      this.$store.commit("app/loginShow", e);
    },
    stick() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 4000) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/mobile/base.css";
</style>


// WEBPACK FOOTER //
// src/components/mobile/base/index.vue